import { ApprovalRequestsTab } from '../common'
import { Request, RequestHistory } from '../ancillarymaterials'
import { ContactInformation } from '../common/detail'
import { selectCurrentFilter } from '../../../selectors/filters'
import {
  APPROVAL_REQUEST_CONFIG,
  ARTYPE_ANCILLARYMATERIALS,
  AR_ID,
  AR_AICODE,
  AR_STATUS,
  AR_EXAMDATE,
} from '../../../constants/ApprovalRequestConstants'

const mapStateToProps = state => ({
  groupByAICode: selectCurrentFilter(state).groupByAICode || false,
})

export const AncillaryMaterialsTab = connect(mapStateToProps)(({ groupByAICode }) => {
  const requestDetailPanels = [
    {
      title: 'Contact Information',
      PanelBody: ContactInformation,
      panelId: 'contactInformationPanel',
    },
    { title: 'Request History', PanelBody: RequestHistory, panelId: 'requestHistoryPanel' },
  ]
  const headerColumns = [
    {
      headerText: { title: 'ID' },
      headerAttributes: { id: 'approvalRequestIdCol' },
      key: [`${APPROVAL_REQUEST_CONFIG[ARTYPE_ANCILLARYMATERIALS].idField}`, 'examDate'],
      sortDir: ['asc', 'asc'],
    },
    {
      headerText: { title: 'AI Code' },
      headerAttributes: { id: 'aiCodeCol' },
      key: ['aiCode', 'examDate'],
      sortDir: ['asc', 'asc'],
    },
    {
      headerText: { title: 'Materials' },
      headerAttributes: { id: 'materialsCol' },
      key: ['ssdId', 'examDate'],
      sortDir: ['asc', 'asc'],
    },
    {
      headerText: { title: 'Exam Date' },
      headerAttributes: { id: 'examDateCol' },
      key: ['examDate', 'aiCode'],
      sortDir: ['asc', 'asc'],
      defaultSort: true,
    },
    {
      headerText: { title: 'Status' },
      headerAttributes: { id: 'statusCol' },
      key: ['statusSortOrder', 'examDate'],
      sortDir: ['asc', 'asc'],
    },
  ]

  const approvalRequestColumns = [
    { header: AR_ID },
    { header: AR_AICODE },
    { header: 'materialsCol', field: 'materialsDescription' },
    { header: AR_EXAMDATE },
    { header: AR_STATUS },
  ]

  return (
    <ApprovalRequestsTab
      title="Ancillary Materials"
      arType={ARTYPE_ANCILLARYMATERIALS}
      tableSummary={`Ancillary materials approval requests are listed in ascending order ${
        groupByAICode ? 'grouped by AI code' : 'by exam date and AI code'
      }.`}
      headerColumns={headerColumns}
      approvalRequestColumns={approvalRequestColumns}
      RequestComponent={Request}
      requestDetailPanels={requestDetailPanels}
    />
  )
})
